import Empty from 'constants/empty';
import { createSelector } from 'reselect';
import { testTargetOffersSelector } from 'selectors/testTarget/offers/testTargetOffersSelector';

const highlightValueOnValueSetsHPSelector = createSelector(testTargetOffersSelector, offers => offers.highlightValueOnValueSetsHP || Empty.Object);

export { highlightValueOnValueSetsHPSelector };
